import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import React from "react";
import CloseIcon from '@mui/icons-material/Close';

const ItemHistory = (props) => {
  const { awskey, zoomIn, setActiveZoom, removeSpecific, setgrouplink, copyUrl, copied } = props
  const ref = React.useRef()

  const zoom = (src, link, awskey) => {
    zoomIn({ src: src, link: link });
    setActiveZoom(awskey)
  };

  return (
    <>

      <img
        src={
          awskey.indexOf(".mp4") > 0
            ? "https://cdn-icons-png.flaticon.com/512/92/92353.png"
            : "https://s3.amazonaws.com/shot.screen1.me/" + awskey
        }

        // onMouseOver={(e) => mouseenter(e)}
        width="64"
        height="64"
        ref={ref}
        alt=""
        onClick={() => zoom(ref.current.getAttribute('src'), "http://shot.screen1.me/" + awskey, awskey)}
      ></img>
      <span className="copyBtn" onClick={(e) => setgrouplink("http://shot.screen1.me/" + awskey + "\n")}>Copy <ContentCopyIcon sx={{ fontSize: 14, color: 'white' }} /></span>
      <span onClick={() => copyUrl(awskey)}>
        {"http://shot.screen1.me/" + awskey}
      </span>
      {copied === awskey && <div className="copied">Copied</div>}
      <div
        className="remove"
        onClick={() => {
          if (
            window.confirm("Are you sure to delete this screenshot?")
          ) {
            removeSpecific(awskey);
            setgrouplink(awskey, "remove");
          }
        }}
      >
        <CloseIcon sx={{ fontSize: 12 }}></CloseIcon>
      </div>
    </>
  );
};

export default ItemHistory;